<div *ngIf="media$ | async; let media">
    <ng-container *ngIf="media?.isProcessing()">
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
            <mat-icon class="ai-icon">smart_toy</mat-icon>
            <span i18n>Processing video...</span>
        </div>
    </ng-container>
    <ng-container *ngIf="!media?.isProcessing()">
        <ng-container *ngIf="isVideoUrl$ | async">
            <app-youtube-link-info-player
                [showYoutubeMetadata]="false"
                [showInput]="false"
                [urlSource]="urlSource"
            ></app-youtube-link-info-player>
        </ng-container>
        <ng-container *ngIf="!(isVideoUrl$ | async)">
            <app-media-view
                *ngIf="media?.mediaType !== MediaType.AUDIO"
                class="trailer-media-player"
                [media]="media"
                [autoplay]="data?.autoplay"
            >
            </app-media-view>
            <app-media-view
                class="audio-player-media"
                *ngIf="media?.mediaType === MediaType.AUDIO"
                [media]="media"
                [autoplay]="data?.autoplay"
            >
            </app-media-view>
        </ng-container>
    </ng-container>
</div>
